/*-----------------------------------------------------------------------------
/ Marketing attribution for Shopify cart attributes
/-----------------------------------------------------------------------------*/
(function() {
  'use strict';

  var STORAGE_KEY = 'eboca.marketing_attribution.v1';
  var SYNC_KEY = 'eboca.marketing_attribution.sync.v1';
  var TTL_DAYS = 90;
  var MAX_VALUE_LENGTH = 500;
  var pendingSync = null;

  var KNOWN_PARAMS = {
    utm_source: true,
    utm_medium: true,
    utm_campaign: true,
    utm_term: true,
    utm_content: true,
    utm_id: true,
    utm_source_platform: true,
    utm_creative_format: true,
    utm_marketing_tactic: true,
    gclid: true,
    gbraid: true,
    wbraid: true,
    fbclid: true,
    msclkid: true,
    ttclid: true,
    li_fat_id: true
  };

  function nowIso() {
    return new Date().toISOString();
  }

  function expiresAt() {
    return Date.now() + (TTL_DAYS * 24 * 60 * 60 * 1000);
  }

  function sanitizeValue(value) {
    if (value == null) return '';
    value = String(value).replace(/[\r\n\t]+/g, ' ').trim();
    return value.slice(0, MAX_VALUE_LENGTH);
  }

  function canUseParam(key) {
    key = String(key || '').toLowerCase();
    return KNOWN_PARAMS[key] || /^utm_[a-z0-9_]{1,64}$/i.test(key);
  }

  function decodeParam(value) {
    try {
      return decodeURIComponent(String(value || '').replace(/\+/g, ' '));
    } catch (e) {
      return '';
    }
  }

  function eachSearchParam(callback) {
    var search = window.location.search ? window.location.search.slice(1) : '';
    if (!search) return;

    search.split('&').forEach(function(pair) {
      if (!pair) return;
      var parts = pair.split('=');
      var key = decodeParam(parts.shift()).toLowerCase();
      var value = decodeParam(parts.join('='));
      callback(key, value);
    });
  }

  function getMarketingParams() {
    var params = {};

    eachSearchParam(function(key, value) {
      value = sanitizeValue(value);
      if (canUseParam(key) && value) {
        params[key] = value;
      }
    });

    return params;
  }

  function serializeParams(params) {
    var pairs = [];

    Object.keys(params).sort().forEach(function(key) {
      pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(params[key]));
    });

    return pairs.join('&');
  }

  function getLandingPage(params) {
    var query = serializeParams(params);
    return sanitizeValue(window.location.pathname + (query ? '?' + query : ''));
  }

  function getExternalReferrer() {
    if (!document.referrer) return '';

    try {
      var referrer = new URL(document.referrer);
      if (referrer.hostname === window.location.hostname) return '';
      return sanitizeValue(referrer.href);
    } catch (e) {
      return sanitizeValue(document.referrer);
    }
  }

  function readJson(key) {
    try {
      var value = window.localStorage.getItem(key);
      return value ? JSON.parse(value) : null;
    } catch (e) {
      return null;
    }
  }

  function writeJson(key, value) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch (e) {
      return false;
    }
  }

  function removeStored(key) {
    try {
      window.localStorage.removeItem(key);
    } catch (e) {}
  }

  function readState() {
    var state = readJson(STORAGE_KEY);

    if (!state) return null;
    if (state.expires_at && state.expires_at < Date.now()) {
      removeStored(STORAGE_KEY);
      removeStored(SYNC_KEY);
      return null;
    }

    return state;
  }

  function writeState(state) {
    state.expires_at = expiresAt();
    writeJson(STORAGE_KEY, state);
  }

  function captureAttribution() {
    var params = getMarketingParams();
    var keys = Object.keys(params);

    if (!keys.length) {
      return readState();
    }

    var touch = {
      params: params,
      landing_page: getLandingPage(params),
      referrer: getExternalReferrer(),
      captured_at: nowIso()
    };
    var state = readState() || {};

    if (!state.first) {
      state.first = touch;
    }

    state.last = touch;
    writeState(state);

    return state;
  }

  function addTouchAttributes(attributes, touch, prefix) {
    if (!touch || !touch.params) return;

    Object.keys(touch.params).forEach(function(key) {
      attributes[prefix + key] = touch.params[key];
    });

    if (touch.landing_page) {
      attributes[prefix + 'utm_landing_page'] = touch.landing_page;
    }

    if (touch.referrer) {
      attributes[prefix + 'utm_referrer'] = touch.referrer;
    }

    if (touch.captured_at) {
      attributes[prefix + 'utm_captured_at'] = touch.captured_at;
    }
  }

  function buildCartAttributes(state) {
    var attributes = {};

    if (!state || !state.last) return attributes;

    addTouchAttributes(attributes, state.last, '');
    addTouchAttributes(attributes, state.first, 'first_');
    attributes.utm_data_source = 'eboca_theme';

    return attributes;
  }

  function stableJson(value) {
    var sorted = {};

    Object.keys(value).sort().forEach(function(key) {
      sorted[key] = value[key];
    });

    return JSON.stringify(sorted);
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.$?*|{}()[\]\\/+^]/g, '\\$&') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function getCartUpdateUrl() {
    if (window.theme && theme.routes && theme.routes.cartUrl) {
      return theme.routes.cartUrl + '/update.js';
    }

    if (window.Shopify && Shopify.routes && Shopify.routes.root) {
      return Shopify.routes.root + 'cart/update.js';
    }

    return '/cart/update.js';
  }

  function encodeAttributes(attributes) {
    return Object.keys(attributes).map(function(key) {
      return encodeURIComponent('attributes[' + key + ']') + '=' + encodeURIComponent(attributes[key]);
    }).join('&');
  }

  function markSynced(hash) {
    writeJson(SYNC_KEY, {
      hash: hash,
      cart_token: getCookie('cart'),
      synced_at: nowIso()
    });
  }

  function wasSynced(hash) {
    var sync = readJson(SYNC_KEY);
    return sync && sync.hash === hash && sync.cart_token === getCookie('cart');
  }

  function postCartAttributes(attributes, keepalive) {
    var body = encodeAttributes(attributes);
    var url = getCartUpdateUrl();

    if (window.fetch) {
      return window.fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          'Accept': 'application/json'
        },
        credentials: 'same-origin',
        keepalive: !!keepalive,
        body: body
      }).then(function(response) {
        if (!response.ok) throw new Error('Attribution sync failed');
        return response;
      });
    }

    return new Promise(function(resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', url, true);
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.onload = function() {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(xhr);
          return;
        }
        reject(new Error('Attribution sync failed'));
      };
      xhr.onerror = reject;
      xhr.send(body);
    });
  }

  function syncCartAttributes(options) {
    options = options || {};

    var state = readState();
    var attributes = buildCartAttributes(state);
    var keys = Object.keys(attributes);
    var hash;

    if (!keys.length) return Promise.resolve();

    hash = stableJson(attributes);

    if (!options.force && wasSynced(hash)) {
      return Promise.resolve();
    }

    if (pendingSync && !options.keepalive) {
      return pendingSync;
    }

    pendingSync = postCartAttributes(attributes, options.keepalive)
      .then(function(response) {
        markSynced(hash);
        return response;
      })
      .catch(function(error) {
        if (window.console && window.console.warn) {
          window.console.warn('[EbocaAttribution] Unable to sync cart attributes', error);
        }
      })
      .then(function(result) {
        pendingSync = null;
        return result;
      });

    return pendingSync;
  }

  function hasCheckoutIntent(target) {
    if (!target || !target.closest) return false;

    return !!target.closest(
      '[name="checkout"], [href="/checkout"], [href$="/checkout"], .checkout_button'
    );
  }

  function hasAddToCartIntent(target) {
    var form = target && target.closest ? target.closest('form') : null;
    var action = form ? form.getAttribute('action') || '' : '';

    return action.indexOf('/cart/add') !== -1;
  }

  function hasCartCheckoutSubmit(event) {
    var form = event.target;
    var action = form && form.getAttribute ? form.getAttribute('action') || '' : '';
    var submitter = event.submitter || document.activeElement;

    if (!form || !action || action.indexOf('/cart') === -1 || action.indexOf('/cart/add') !== -1) {
      return false;
    }

    if (submitter && submitter.name === 'update') {
      return false;
    }

    return true;
  }

  function bindEvents() {
    document.addEventListener('click', function(event) {
      if (hasCheckoutIntent(event.target)) {
        syncCartAttributes({ force: true, keepalive: true });
        return;
      }

      if (hasAddToCartIntent(event.target)) {
        syncCartAttributes({ force: true });
      }
    }, true);

    document.addEventListener('submit', function(event) {
      if (hasCheckoutIntent(event.submitter || document.activeElement) || hasCartCheckoutSubmit(event)) {
        syncCartAttributes({ force: true, keepalive: true });
        return;
      }

      if (hasAddToCartIntent(event.target)) {
        syncCartAttributes({ force: true });
      }
    }, true);

    if (window.jQuery) {
      jQuery(document.body).on('afterAddItem.ajaxCart afterCartLoad.ajaxCart', function() {
        syncCartAttributes({ force: true });
      });
    }
  }

  captureAttribution();
  syncCartAttributes();
  bindEvents();

  window.EbocaAttribution = {
    capture: captureAttribution,
    flush: function() {
      return syncCartAttributes({ force: true });
    },
    get: readState
  };
})();
